import Grid from '@/components/atoms/legacy/Grid';
import Heading, { HeadingLevels } from '@/components/atoms/legacy/Heading';
import Wrapper from '@/components/atoms/legacy/Wrapper';
import Breadcrumb from '@/components/molecules/Breadcrumb';
import PageHeader from '@/components/organisms/PageHeader';
import scrollIntoView from '@/lib/scrollIntoView';
import React, { useMemo } from 'react';

const PrivacyPolicyTemplate: React.FC = () => {
  const p1El = React.useRef(null);
  const p2El = React.useRef(null);
  const p3El = React.useRef(null);
  const p4El = React.useRef(null);
  const p5El = React.useRef(null);
  const p6El = React.useRef(null);
  const p7El = React.useRef(null);
  const p8El = React.useRef(null);
  const p9El = React.useRef(null);
  const p10El = React.useRef(null);
  const p11El = React.useRef(null);
  const p12El = React.useRef(null);
  const p13El = React.useRef(null);
  const p14El = React.useRef(null);

  const nav = useMemo(
    () => [
      {
        text: '1. Welcome to EV.com - Electric Vehicle Marketplace',
        el: p1El,
      },
      {
        text: '2. Your Account',
        el: p2El,
      },
      {
        text: '3. Using the Services',
        el: p3El,
      },
      {
        text: '4. Abusing EV.com - Electric Vehicle Marketplace  Services',
        el: p4El,
      },
      {
        text: '5. Global Marketplace',
        el: p5El,
      },
      {
        text: '6. Fees and Services',
        el: p6El,
      },
      {
        text: '7. Content',
        el: p7El,
      },
      {
        text: '8. Reporting Intellectual Property Infringements (Verified Rights Owners - VeRO)',
        el: p8El,
      },
      {
        text: '9. Disclaimers and Limitations of Liability',
        el: p9El,
      },
      {
        text: '10. Indemnification',
        el: p10El,
      },
      {
        text: '11. Personal Information',
        el: p11El,
      },
      {
        text: '12. Reviews',
        el: p12El,
      },
      {
        text: '13. General',
        el: p13El,
      },
      {
        text: '14. Mobile Devices Terms',
        el: p14El,
      },
    ],
    []
  );

  return (
    <>
      <Wrapper className="mb-[8px]">
        <Breadcrumb
          links={[
            {
              text: 'Home',
              href: '/',
            },
            {
              text: 'Terms And Conditions',
              href: '/terms_and_conditions',
            },
          ]}
        />
      </Wrapper>
      <Wrapper className="mb-[20px]">
        <PageHeader label="Terms And Conditions" />
      </Wrapper>
      <Wrapper className="bg-white pt-[20px]">
        <Grid>
          <section className="col-span-full l:col-span-3">
            <nav className="mb-[60px] bg-blue-light p-[20px] l:sticky l:top-0">
              {nav.map(({ text, el }) => (
                <button
                  key={text}
                  className="w-full p-[10px] text-left text-bodyBold4 text-neutral-800"
                  onClick={() => {
                    if (el.current) {
                      scrollIntoView(el.current);
                    }
                  }}
                >
                  {text}
                </button>
              ))}
            </nav>
          </section>
          <article className="col-span-full l:col-span-8 l:col-start-5">
            <section ref={p1El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                1. Welcome to EV.com - Electric Vehicle Marketplace
              </Heading>
              <p className="text-microNormal text-neutral-800">
                Thanks for stopping by. These Terms of Use, the Privacy Policy,
                the Mobile Devices Terms, and all policies posted on our site
                set out the terms on which we offer you access to and use of our
                site, services, applications, and tools (collectively
                &quot;Services&quot;). You can find an overview of our policies
                here. All policies, the Mobile Devices Terms, and the Privacy
                Policy are incorporated into these Terms of Use. You agree to
                comply with all the above when accessing or using our Services.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                EV.com Inc., 5243 Steeles Ave W, Toronto, Ontario M9L 2W2, CA
              </p>
            </section>
            <section ref={p2El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                2. Your Account
              </Heading>
              <p className="text-microNormal text-neutral-800">
                In order to access and use some or a portion of the Services,
                you may be required to register with us and set up an account
                with your email address and a password (your “Account”). The
                email address you provide will be your email address, and you
                are solely responsible for maintaining the confidentiality of
                your password. You are solely responsible for all activities
                that occur under your Account. Therefore, you should protect
                your password and make your password difficult for others to
                guess. You will not transfer your Account to another party
                without our consent.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                You may connect to the Services with a third-party service, and
                you give us permission to access, store, and use your
                information from that service as permitted by that service and
                as may be described in our Privacy Policy. If you believe your
                Account may have been compromised or misused, contact us
                immediately at EV.com - Electric Vehicle Marketplace Customer
                Support.
              </p>
            </section>
            <section ref={p3El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                3. Using the Services
              </Heading>
              <p className="text-microNormal text-neutral-800">
                When using EV.com - Electric Vehicle Marketplace , you agree to
                post in the appropriate category or area and refrain from
                engaging in any of the following activities:
              </p>
              <br />
              <ul className="list-disc pl-[20px] text-microNormal text-neutral-800">
                <li>Violating any laws or our Prohibited Content Policy</li>
                <li>Posting false or misleading information</li>
                <li>Infringing any third-party rights</li>
                <li>
                  Distributing or containing spam, chain letters, or pyramid
                  schemes
                </li>
                <li>
                  Distributing viruses or any other technologies that may harm
                  EV.com - Electric Vehicle Marketplace or the interests or
                  property of its users
                </li>
                <li>
                  Impeding the proper functioning of EV.com - Electric Vehicle
                  Marketplace or imposing an unreasonable load on its
                  infrastructure
                </li>
                <li>
                  Copying, modifying, or distributing any other person&apos;s
                  content
                </li>
                <li>
                  Using any robot, spider, scraper or other automated means to
                  access EV.com - Electric Vehicle Marketplace and collect
                  content for any purpose without our express written permission
                </li>
                <li>
                  Harvesting or otherwise collecting information about others,
                  including email addresses, without their consent
                </li>
                <li>
                  Bypassing measures used to prevent or restrict access to
                  EV.com - Electric Vehicle Marketplace.
                </li>
              </ul>
            </section>
            <section ref={p4El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                4. Abusing EV.com - Electric Vehicle Marketplace Services
              </Heading>
              <p className="text-microNormal text-neutral-800">
                If you encounter any issues or offensive content while using our
                Services, please utilize the flagging system so that we can work
                together to maintain a properly functioning site. We reserve the
                right to limit or terminate our Services, remove hosted content,
                and take legal and technical action to prevent users who we
                believe are creating problems or acting contrary to our policies
                from accessing EV.com - Electric Vehicle Marketplace . However,
                regardless of whether we choose to take any of these actions or
                not, we do not assume any responsibility for monitoring EV.com -
                Electric Vehicle Marketplace or for unauthorized or unlawful
                content or use of EV.com - Electric Vehicle Marketplace by
                users.
              </p>
            </section>
            <section ref={p5El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                5. Global Marketplace
              </Heading>
              <p className="text-microNormal text-neutral-800">
                In addition to the rights granted under &quot;Content&quot;
                below, some features of EV.com - Electric Vehicle Marketplace
                may display your advertisement on other classifieds sites in
                other countries that are part of our network. By using our
                Services, you agree to allow your ads to appear on these other
                sites. The terms for our other sites are similar to these terms,
                but you may be subject to additional laws or other restrictions
                in the countries where your ad is posted. If you choose to post
                your ad to another site, you are responsible for ensuring that
                it complies with our other site policies. We reserve the right
                to remove your ad if it is flagged on any of our sites or if we
                believe it causes issues or violates any laws or policies.
              </p>
            </section>
            <section ref={p6El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                6. Fees and Services
              </Heading>
              <p className="text-microNormal text-neutral-800">
                Using the Services on EV.com - Electric Vehicle Marketplace is
                generally free of charge. However, we may charge fees for
                certain Services. If there is a fee associated with the service
                you use, you will have the opportunity to review and accept that
                charge. Our fees are stated in Canadian Dollars and are subject
                to change from time to time. We will notify you of any changes
                to our fee policy by posting such changes on the site. In some
                cases, we may temporarily change our fees for promotional events
                or new services, and such changes are effective when we announce
                the promotional event or new service. Please note that our fees
                are non-refundable, and you are responsible for paying them when
                they&apos;re due. Failure to do so may result in your inability
                to use the Services. If your payment method fails or your
                account is past due, we may collect fees owed using other
                collection mechanisms.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                If applicable, Canadian taxes associated with our Services will
                be collected. You agree to provide accurate address information
                necessary for EV.com - Electric Vehicle Marketplace to comply
                with its obligations under applicable law. If you fail to
                provide such information, EV.com - Electric Vehicle Marketplace
                may, at its discretion, determine and collect appropriate taxes.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                You are solely responsible for collecting and remitting any
                applicable taxes resulting from the sale of your items or
                services listed on EV.com - Electric Vehicle Marketplace .
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                Although many features of the Services are available across the
                EV.com - Electric Vehicle Marketplace websites and associated
                mobile applications, some features and functionality may vary
                depending on the website and/or mobile device you use to access
                the Services.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                To use certain functionality of our EV.com - Electric Vehicle
                Marketplace Digital Retailing Solution, you must be a resident
                of Canada and capable of forming a binding contract under
                applicable law, including being above the age of majority in the
                Province or Territory where you reside. The EV.com - Electric
                Vehicle Marketplace Digital Retailing Solution may not be
                available for all vehicle listings, and it may be subject to
                additional requirements as set out in the EV.com - Electric
                Vehicle Marketplace Digital Retailing Solution. You agree to
                comply with all applicable laws and regulations in respect of
                any purchase you may ultimately make from a seller through
                EV.com - Electric Vehicle Marketplace , including any licensing
                and/or insurance requirements.
              </p>
            </section>
            <section ref={p7El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                7. Content
              </Heading>
              <p className="text-microNormal text-neutral-800">
                EV.com - Electric Vehicle Marketplace contains content from us,
                you, and other users (as well as from our third-party service
                providers). You agree not to copy, modify, resell, or distribute
                EV.com - Electric Vehicle Marketplace , our copyrights, or
                trademarks. By submitting content to EV.com - Electric Vehicle
                Marketplace , you grant us a non-exclusive, worldwide,
                perpetual, irrevocable, royalty-free, sub-licensable right to
                exercise the copyright, publicity, and database rights to that
                content. If you believe that your rights have been violated,
                please notify EV.com - Electric Vehicle Marketplace Customer
                Support, and we will investigate the matter. We reserve the
                right to remove content where we have grounds for suspecting the
                violation of these terms or the rights of any other party.
              </p>
            </section>
            <section ref={p8El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                8. Reporting Intellectual Property Infringements (Verified
                Rights Owners - VeRO)
              </Heading>
              <p className="text-microNormal text-neutral-800">
                Do not post content that infringes the rights of third parties.
                This includes, but is not limited to, content that infringes on
                intellectual property rights such as copyright and trademark
                (e.g., offering counterfeit items for sale). Do not post content
                that contains any reference to or likeness of any identifiable
                third parties, unless consent has been obtained from each such
                individual as may be required. We reserve the right to remove
                content where we have grounds for suspecting the violation of
                these terms, our policies, or any party&apos;s rights. The
                following steps are for reporting a listing to EV.com - Electric
                Vehicle Marketplace that you believe to be infringing on your
                intellectual property rights. Only the intellectual property
                rights owner can report potentially infringing items or listings
                through EV.com - Electric Vehicle Marketplace&apos;s VeRO
                Program. If you have a good faith belief that a listing on any
                of the Services infringes your copyright, trademark, or other
                intellectual property rights, all you need to do is download our
                Notice of Claimed Infringement (NOCI) form, fill it out, and
                email it to EV.com - Electric Vehicle Marketplace at the email
                address provided on the form. After we receive your first NOCI,
                EV.com - Electric Vehicle Marketplace will confirm your
                enrollment in our program. We reserve the right to share, in
                accordance with applicable law, the completed NOCI form with the
                third party that originally posted the potentially infringing
                listing.
              </p>
            </section>
            <section ref={p9El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                9. Disclaimers and Limitations of Liability
              </Heading>
              <p className="text-microNormal text-neutral-800">
                EV.com - Electric Vehicle Marketplace provides the Services
                &quot;as is&quot; and &quot;as available.&quot; You agree not to
                hold us responsible for anything that other users post or do.
                You also agree not to hold us responsible for the payment
                processing of other service providers, such as Adyen (each a
                &quot;Third Party Payment Processor&quot;). If you link a Third
                Party Payment Processor account to your EV.com - Electric
                Vehicle Marketplace account, you acknowledge and agree that by
                making payments through EV.com - Electric Vehicle Marketplace
                with that Third Party Payment Processor, you are bound by that
                Third Party Payment Processor&apos;s applicable terms and
                conditions, and we are not liable for any loss, claims, or
                damages arising in connection with that third party&apos;s
                services. As most of the content on the Services comes from
                other users, we do not guarantee the accuracy, completeness,
                efficacy, or timeliness of any postings or user communications
                or the quality, safety, or legality of what is offered. We also
                cannot guarantee continuous or secure access to our Services.
                Notification functionality in our Services may not occur in
                real-time, and it is subject to delays beyond our control,
                including without limitation, delays or latency due to your
                physical location or your wireless data service provider&apos;s
                network. Accordingly, to the extent legally permitted, we
                expressly disclaim all warranties, representations, and
                conditions, express or implied, including those of quality,
                merchantability, merchantable quality, durability, fitness for a
                particular purpose, and those arising by statute. We are not
                liable for any loss, whether of money (including profit),
                goodwill, or reputation, or any special, indirect, or
                consequential damages arising out of your use of EV.com -
                Electric Vehicle Marketplace , even if you advise us or we could
                reasonably foresee the possibility of any such damage occurring.
                Some jurisdictions do not allow the disclaimer of warranties or
                exclusion of damages, so such disclaimers and exclusions may not
                apply to you.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                Despite the previous paragraph, if we are found to be liable,
                our liability to you or any third party (whether in contract,
                tort, negligence, strict liability in tort, by statute, or
                otherwise) is limited to the greater of (a) the total fees you
                pay to us in the 12 months prior to the action giving rise to
                liability, and (b) 100 Canadian Dollars.
              </p>
            </section>
            <section ref={p10El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                10. Indemnification
              </Heading>
              <p className="text-microNormal text-neutral-800">
                You will indemnify and hold harmless EV.com - Electric Vehicle
                Marketplace and its affiliates and our and their respective
                officers, directors, agents, and employees (each an
                &quot;Indemnified Party&quot;), from any claim made by any third
                party, together with any amounts payable to the third party
                whether in settlement or as may otherwise be awarded, and
                reasonable legal costs incurred by any of the Indemnified
                Parties, arising from or relating to your use of the Services,
                any alleged violation by you of the applicable terms, and any
                alleged violation by you of any applicable law or regulation. We
                reserve the right, at our own expense, to assume the exclusive
                defense and control of any matter subject to indemnification by
                you, but doing so will not excuse your indemnity obligations.
              </p>
            </section>
            <section ref={p11El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                11. Personal Information
              </Heading>
              <p className="text-microNormal text-neutral-800">
                By using EV.com - Electric Vehicle Marketplace Services, you
                agree to allow the collection, transfer, storage, and use of
                your personal information by EV.com - Electric Vehicle
                Marketplace on servers located in the United States and the
                European Union as described in our privacy policy.
              </p>
            </section>
            <section ref={p12El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                12. Reviews
              </Heading>
              <p className="text-microNormal text-neutral-800">
                You may be requested to provide a review when communicating with
                other users on EV.com - Electric Vehicle Marketplace . Reviews
                consist of a rating of 1-5 stars and selected reasons for the
                review. Your submitted review, username, profile photo (if
                available), and the category of the seller&apos;s listing will
                be made public. User reviews should be made in good faith,
                ensuring that both you and the other user are depicting your
                interaction fairly. When leaving a review on another user&apos;s
                account, the review should:
              </p>
              <br />
              <ul className="list-disc pl-[20px] text-microNormal text-neutral-800">
                <li>
                  Be truthful to what occurred between you and the other user.
                </li>
                <li>
                  Not be left in an attempt to harass or abuse another user.
                </li>
                <li>
                  Not be left in an attempt to manipulate or mislead other
                  users.
                </li>
              </ul>
              <br />
              <p className="text-microNormal text-neutral-800">
                To maintain the integrity of the review system, users cannot
                edit or remove reviews on their own profile or someone
                else&apos;s. EV.com - Electric Vehicle Marketplace will not
                mediate review-related disputes. User reviews reflect the
                opinions of individual EV.com - Electric Vehicle Marketplace
                users and do not represent the opinion of EV.com - Electric
                Vehicle Marketplace.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                We reserve the right to remove reviews that violate our policies
                or guidelines. For more information, please refer to our User
                Review policy.
              </p>
            </section>
            <section ref={p13El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                13. General
              </Heading>
              <p className="text-microNormal text-neutral-800">
                These terms and the other policies posted on the Services
                constitute the entire agreement between us and you, superseding
                any prior agreements. This agreement is governed by the laws of
                the Province of Ontario and the federal laws of Canada
                applicable therein. We both submit to the jurisdiction of the
                courts of the Province of Ontario. This will not affect your
                statutory rights if you are a consumer and applicable consumer
                law requires the application of another law for certain topics.
                If we do not enforce any particular provision, we are not
                waiving our right to do so later. If a court strikes down any of
                these terms, the remaining terms will survive. We may
                automatically assign this agreement in our sole discretion in
                accordance with the notice provision below (our assignment to an
                affiliate will not require notice). Except for notices relating
                to illegal or infringing content, your notices to us must be
                sent by registered mail to:
              </p>
              <br />
              <div className="text-microNormal text-neutral-800">
                <div>
                  EV.com - Electric Vehicle Marketplace , Attn: Legal Department
                </div>
                <div>5243 Steeles Ave W,</div>
                <div>Toronto, Ontario M9L 2W2, CA</div>
              </div>
              <br />
              <p className="text-microNormal text-neutral-800">
                We may give notice to you at either the email or postal address
                you provide to us during the registration process. Notice will
                be deemed received and properly served 24 hours after an email
                is sent or three days after the date of posting of any letter.
                In providing the Services, we may provide you with certain
                communications, such as service announcements and administrative
                messages. These communications are considered part of the
                Services and your account with us, and you may not be able to
                opt-out of receiving them.
              </p>
            </section>
            <section ref={p14El} className="mb-[60px]">
              <Heading
                className="mb-[10px] text-h4Regular"
                level={HeadingLevels.H2}
              >
                14. Mobile Devices Terms
              </Heading>
              <p className="text-microNormal text-neutral-800">
                The Mobile Devices Terms apply to users who access the Services
                through the EV.com - Electric Vehicle Marketplace mobile
                application (&quot;Application&quot;) on a mobile device. In
                addition to the Mobile Privacy and Legal Notice or End User
                License Agreement, you agree to these Mobile Devices Terms by
                using the Application.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                You are permitted to use the Application as long as you comply
                with the following limitations: do not modify, copy, sell,
                license, or otherwise commercialize the Application or any
                associated software or information, do not transfer rights to
                the Application, and do not use the Application in a way that
                could damage it or interfere with other users&apos; enjoyment of
                it. You must also comply with applicable laws and third-party
                agreements, such as your wireless data service agreement.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                Note that not all functionality available on the EV.com -
                Electric Vehicle Marketplace website may be available on the
                Application, and the Application&apos;s use is at your own risk.
                You are responsible for any damage to your mobile device or loss
                of data resulting from using the Application.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                EV.com - Electric Vehicle Marketplace owns all rights to its
                Applications and associated proprietary technology, and you may
                not modify, adapt, translate, prepare derivative works from,
                decompile, reverse-engineer, disassemble, or attempt to derive
                source code from any Application. Additionally, you may not
                remove or alter any of EV.com - Electric Vehicle
                Marketplace&apos;s copyright, trademark, or other proprietary
                rights notices.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                The Application or its underlying technology may not be
                downloaded, exported, or re-exported to any country under United
                States embargo, anyone on the U.S. Department of the Treasury’s
                list of Specially Designated Nationals or on the U.S. Department
                of Commerce’s Denied Party or Entity List, or any prohibited
                country, person, end-user, or entity specified by U.S. export
                laws. You are responsible for complying with foreign and
                domestic laws and trade regulations when using the Application.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                Note that there may be additional terms and conditions based on
                the mobile device on which the Application is installed.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                For iOS devices, these terms are an agreement between you and
                us, not Apple. Apple is not responsible for the Application or
                its content. You may only use the Application on an iOS device
                that you own or control and in accordance with Apple&apos;s
                Usage Rules for the App Store. Apple is not obligated to provide
                maintenance or support services for the Application, nor is it
                responsible for any third-party intellectual property
                infringement claims or claims related to your use of the
                Application. Apple and its subsidiaries are third-party
                beneficiaries of these terms, and Apple has the right to enforce
                these terms against you.
              </p>
              <br />
              <p className="text-microNormal text-neutral-800">
                For Android devices, these terms are an agreement between you
                and us, not Google. Google is not responsible for the
                Application or its content. Your use of the Application must
                comply with Google&apos;s then-current Google Play Store Terms
                of Service. Google is only a provider of the Google Play Store
                and has no obligation or liability to you regarding the
                Application or these terms. You acknowledge that Google is a
                third-party beneficiary of these terms as they relate to the
                Application.
              </p>
              <br />
            </section>
          </article>
        </Grid>
      </Wrapper>
    </>
  );
};

export default PrivacyPolicyTemplate;
